/**
 * Mietabrechnung: strip address lines on document create (and legacy template PUT),
 * then redirect to Nachrichtenversand.
 */
;(function registerLuxFetchHandlerRentSettlement() {
  const RENT_SETTLEMENT_PAGE_RE = /^\/rent-settlement\/(?:done\/send|due\/execute)/
  const DOCUMENTS_API_PATH = '/services/pmp-document/api/v1/documents'
  const documentTemplateApiUrl = '/services/pmp-document/api/v1/documents/template'
  let savedRedirectUrl = ''

  function isDocumentsCreatePost(url, method) {
    if (method !== 'POST') return false
    try {
      const pathname = new URL(url, window.location.origin).pathname.replace(/\/$/, '')
      return pathname === DOCUMENTS_API_PATH
    } catch {
      return false
    }
  }

  function clearRecipientAddressLinesInPdfData(data) {
    const arr = Array.isArray(data) ? data : [data]
    for (const item of arr) {
      if (item?.pdfDataJsonString && typeof item.pdfDataJsonString === 'string') {
        try {
          const pdfData = JSON.parse(item.pdfDataJsonString)
          if (pdfData.html && typeof pdfData.html === 'string') {
            pdfData.html = pdfData.html.replace(
              /(<div[^>]*class\s*=\s*["'][^"']*management-company[^"']*["'][^>]*>)[^<]*(<\/div>)/gi,
              '$1$2',
            )
            pdfData.html = pdfData.html.replace(
              /(<div[^>]*class\s*=\s*["'][^"']*recipient-address-line[^"']*["'][^>]*>)[^<]*(<\/div>)/gi,
              '$1$2',
            )
            item.pdfDataJsonString = JSON.stringify(pdfData)
          }
        } catch (error) {
          console.warn('Error clearing recipient address lines in PDF data:', error)
        }
      }

      // New create POST may send HTML (or JSON with html) in pdfData.
      if (item?.pdfData && typeof item.pdfData === 'string') {
        try {
          const parsed = JSON.parse(item.pdfData)
          if (parsed.html && typeof parsed.html === 'string') {
            parsed.html = parsed.html.replace(
              /(<div[^>]*class\s*=\s*["'][^"']*management-company[^"']*["'][^>]*>)[^<]*(<\/div>)/gi,
              '$1$2',
            )
            parsed.html = parsed.html.replace(
              /(<div[^>]*class\s*=\s*["'][^"']*recipient-address-line[^"']*["'][^>]*>)[^<]*(<\/div>)/gi,
              '$1$2',
            )
            item.pdfData = JSON.stringify(parsed)
          }
        } catch {
          if (item.pdfData.includes('recipient-address-line') || item.pdfData.includes('management-company')) {
            item.pdfData = item.pdfData
              .replace(
                /(<div[^>]*class\s*=\s*["'][^"']*management-company[^"']*["'][^>]*>)[^<]*(<\/div>)/gi,
                '$1$2',
              )
              .replace(
                /(<div[^>]*class\s*=\s*["'][^"']*recipient-address-line[^"']*["'][^>]*>)[^<]*(<\/div>)/gi,
                '$1$2',
              )
          }
        }
      }
    }
    return Array.isArray(data) ? arr : arr[0]
  }

  function parseRequestBody(body) {
    if (typeof body === 'string') {
      try {
        return JSON.parse(body)
      } catch {
        return null
      }
    }
    if (body != null && typeof body === 'object' && !(body instanceof FormData) && !(body instanceof Blob)) {
      return body
    }
    return null
  }

  function setRedirectFromDocuments(docs) {
    const arr = Array.isArray(docs) ? docs : docs?.content
    if (!Array.isArray(arr) || arr.length === 0) return
    const ids = arr.map((d) => d.sourceId).filter((x) => x != null && Number(x) > 0)
    const documentIds = arr.map((d) => d.id).filter((x) => x != null && Number(x) > 0)
    // Rent settlement loads documents via documentIds only — never redirect without them.
    if (ids.length === 0 || documentIds.length === 0) return
    savedRedirectUrl = `/nachrichtenversand?type=rent-settlement&sourceIds=${ids.join(',')}&documentIds=${documentIds.join(',')}`
  }

  luxRegisterFetchHandler({
    id: 'rent-settlement',
    priority: 30,
    match(ctx) {
      if (!RENT_SETTLEMENT_PAGE_RE.test(ctx.pathname)) return false
      return ctx.url.includes(DOCUMENTS_API_PATH)
    },
    handle(ctx, nativeFetch) {
      const u = ctx.url

      // Legacy template PUT: strip addresses, then redirect if we already have a URL.
      if (u.includes(documentTemplateApiUrl)) {
        const run = async () => {
          let url = ctx.isStringUrl ? ctx.args[0] : ctx.args[0].url
          let method = (ctx.isStringUrl ? ctx.args[1]?.method : ctx.args[0].method) || 'GET'
          let headers = ctx.isStringUrl ? ctx.args[1]?.headers : ctx.args[0].headers
          let body = ctx.isStringUrl ? ctx.args[1]?.body : undefined

          if (body === undefined && !ctx.isStringUrl && ctx.args[0]?.body) {
            body = await ctx.args[0].clone().text()
          }
          if (body != null && typeof body === 'string') {
            try {
              const data = JSON.parse(body)
              const newBody = JSON.stringify(clearRecipientAddressLinesInPdfData(data))
              const init = ctx.isStringUrl
                ? { ...ctx.args[1], body: newBody }
                : { method, headers, body: newBody }
              const res = ctx.isStringUrl
                ? await nativeFetch.apply(this, [url, init])
                : await nativeFetch.apply(this, [new Request(url, init)])
              if (savedRedirectUrl) {
                window.location.replace(savedRedirectUrl)
                savedRedirectUrl = ''
              }
              return res
            } catch {
              return nativeFetch.apply(this, ctx.args)
            }
          }
          const res = await nativeFetch.apply(this, ctx.args)
          if (savedRedirectUrl) {
            window.location.replace(savedRedirectUrl)
            savedRedirectUrl = ''
          }
          return res
        }
        return run()
      }

      // New flow: POST /documents — strip addresses, capture redirect, navigate after create.
      if (isDocumentsCreatePost(u, ctx.method)) {
        const run = async () => {
          let body = ctx.isStringUrl ? ctx.args[1]?.body : undefined
          if (body === undefined && !ctx.isStringUrl && ctx.args[0]?.body) {
            body = await ctx.args[0].clone().text()
          }

          const parsed = parseRequestBody(body)
          if (!Array.isArray(parsed) || parsed.length === 0) {
            return nativeFetch.apply(this, ctx.args)
          }

          // New Impower flow posts render payload on create. Empty shells still use template PUT.
          const hasRenderPayload = parsed.some(
            (entry) =>
              (typeof entry?.pdfData === 'string' && entry.pdfData.length > 0) ||
              (typeof entry?.pdfDataJsonString === 'string' && entry.pdfDataJsonString.length > 0),
          )

          const newBody = JSON.stringify(clearRecipientAddressLinesInPdfData(parsed))
          const response = ctx.isStringUrl
            ? await nativeFetch.apply(this, [ctx.args[0], { ...(ctx.args[1] || {}), body: newBody }])
            : await nativeFetch.apply(this, [
                ctx.args[0].url,
                {
                  method: ctx.args[0].method,
                  headers: ctx.args[0].headers,
                  body: newBody,
                  credentials: ctx.args[0].credentials,
                },
              ])

          // Only leave Impower after a successful create that includes real document ids.
          // Request bodies usually have sourceIds but not document ids — do not build/navigate from them.
          if (response.ok) {
            try {
              const created = await response.clone().json()
              setRedirectFromDocuments(created)
            } catch {
              // ignore
            }

            if (hasRenderPayload && savedRedirectUrl) {
              window.location.replace(savedRedirectUrl)
              savedRedirectUrl = ''
            }
          }

          return response
        }
        return run()
      }

      // Do not overwrite redirect from GETs / polling.
      return nativeFetch.apply(this, ctx.args)
    },
  })
})()
